<template>
  <div class="v2026-col-main">
    <template v-if="incognitoActive">
      <div class="v2026-incognito-header">
        <div class="v2026-incognito-left">
          <span class="v2026-incognito-glyph" aria-hidden="true"
                :style="{ '-webkit-mask-image': 'url(' + stealthIcon + ')', 'mask-image': 'url(' + stealthIcon + ')' }"></span>
          <span class="v2026-incognito-label">อ่านแชทแบบไม่ระบุตัวตน</span>
        </div>
        <button type="button" class="v2026-incognito-close" @click="$emit('closeStealth')">
          <i class="fas fa-times"></i> ปิดแชท
        </button>
      </div>
      <div class="message-display py-4" id="messageDisplay" ref="messageDisplay"
           @scroll.passive="$emit('incognitoScroll', $event)">
        <div class="v2026-incognito-status" v-if="incognitoLoading">
          <i class="fas fa-spinner fa-pulse"></i> Loading...
        </div>
        <div class="v2026-incognito-status" v-else-if="!incognitoMessages || incognitoMessages.length === 0">
          ไม่มีข้อความในแชทนี้
        </div>
        <template v-else>
          <div v-for="(message, index) in incognitoMessages" :key="index">
            <template v-if="message.id > 0">
              <customer-chat :message="message" :selectedFile="[]" v-if="message.own === 0"/>
              <admin-chat :message="message" :selectedFile="[]" v-else/>
            </template>
            <template v-else>
              <div class="pb-4 text-center">
                <i class="fas fa-spinner fa-pulse"></i> Loading...
              </div>
            </template>
          </div>
        </template>
      </div>
    </template>
    <template v-else-if="selectedConversation">
      <customer-information ref="infoBox" @clearConversation="$emit('clearConversation')" @clearReminder="$emit('clearReminder')"
                            @toggleCustomerInfo="$emit('toggleCustomerInfo')" :selectedConversation="selectedConversation"/>
      <div class="message-display py-4" id="messageDisplay" ref="messageDisplay"
           @scroll.passive="$emit('messageScroll', $event)" v-if="messages">
        <div v-for="(message, index) in messages" :key="message.id || 'loading-' + index">
          <template v-if="message.id > 0">
            <customer-chat
            :message="message"
            :selectedFile="selectedFile"
            @onSelectAttachmentFile="(attachment, isChecked) => $emit('selectAttachmentFile', attachment, isChecked)"
            @onSelectAttachment="attachment => $emit('selectAttachment', attachment)"
            v-if="message.own === 0"/>
            <admin-chat
            :message="message"
            :selectedFile="selectedFile"
            @onSelectAttachmentFile="(attachment, isChecked) => $emit('selectAttachmentFile', attachment, isChecked)"
            @onSelectAttachment="attachment => $emit('selectAttachment', attachment)"
            v-else/>
          </template>
          <template v-else>
            <div class="pb-4 text-center">
              <i class="fas fa-spinner fa-pulse"></i> Loading...
            </div>
          </template>
        </div>
      </div>
      <template  v-if="selectedFile.length > 0">
        <div class="d-flex justify-content-center align-items-center" style="gap: 5px;">
          <button @click="$emit('downloadFiles')" class="download-button capitalize">
            ดาวน์โหลดไฟล์ ({{ selectedFile.length }})
          </button>
        </div>
      </template>
      <message-box ref="messageBox" :selectedConversation="selectedConversation"></message-box>
    </template>
    <div class="v2026-empty" v-else>
      <img src="https://beneat.co/static/img/main-logo.svg" alt="BeNeat">
      <p>เลือกแชทที่คุณต้องการสนทนา</p>
    </div>
  </div>
</template>

<script>
// AdminChat / CustomerChat stay the ORIGINALS; their skin is restyled here through scoped :deep(),
// which only matches nodes rendered inside THIS component — other consumers are untouched.
import AdminChat from '@/components/coversation/AdminChat'
import CustomerChat from '@/components/coversation/CustomerChat'
import CustomerInformationV2026 from '@/components/coversation/CustomerInformationV2026'
import MessageBoxV2026 from '@/components/coversation/MessageBoxV2026'

export default {
  name: 'MainPanelV2026',
  components: {
    AdminChat,
    CustomerChat,
    CustomerInformation: CustomerInformationV2026,
    MessageBox: MessageBoxV2026
  },
  props: {
    selectedConversation: {
      type: Object,
      default: null
    },
    messages: {
      type: Array,
      default: () => []
    },
    selectedFile: {
      type: Array,
      default: () => []
    },
    messageDisplayHeight: {
      type: Number,
      default: 0
    },
    // Deliberately separate from `messages` / `selectedConversation`, so the store and the normal
    // view are never touched while incognito is active.
    incognitoActive: {
      type: Boolean,
      default: false
    },
    incognitoConversation: {
      type: Object,
      default: null
    },
    incognitoMessages: {
      type: Array,
      default: () => []
    },
    incognitoLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      stealthIcon: require('@/assets/icons2026/incognito.svg')
    }
  },
  methods: {
    // Public API — re-exposes the inner refs the parent used to reach into directly.
    getInfoBoxHeight () {
      return this.$refs.infoBox ? this.$refs.infoBox.$el.clientHeight : 0
    },
    getMessageBoxHeight () {
      return this.$refs.messageBox ? this.$refs.messageBox.$el.clientHeight : 0
    },
    clearMessageBox () {
      if (this.$refs.messageBox) {
        this.$refs.messageBox.clearMessage()
      }
    },
    setReminder (value) {
      if (this.$refs.messageBox) {
        this.$refs.messageBox.remindAt = value
      }
    },
    scrollMessageToBottom () {
      if (this.$refs.messageDisplay) {
        this.$refs.messageDisplay.scrollTop = this.$refs.messageDisplay.scrollHeight
      }
    },
    // Returns the .message-display scroll element so the parent can run its own scrollTop math.
    getMessageScrollEl () {
      return this.$refs.messageDisplay || null
    },
    // infoBox / messageBox only exist once a conversation is selected and mounted.
    isPanelReady () {
      return !!(this.$refs.infoBox && this.$refs.messageBox)
    }
  }
}
</script>

<style lang="scss" scoped>
.v2026-col-main {
  --v2026-teal:           #12A89F;
  --v2026-teal-hover:     #159C96;
  --v2026-surface:        #FFFFFF;
  --v2026-surface-sunken: #F2F4F7;
  --v2026-admin-bubble:   #E6F7F6;
  --v2026-border:         #E4E7EC;
  --v2026-text:           #101828;
  --v2026-text-secondary: #667085;
  --v2026-text-muted:     #98A2B3;
  --v2026-r-bubble: 16px;
  --v2026-r-box:    14px;

  --v2026-red:       #FF2D55;
  --v2026-red-hover: #E11D48;
  --v2026-icon:      #475467;
  --v2026-ctrl-h:    36px;
  --v2026-r-btn:     4px;
  --v2026-fs-ctrl:   13px;

  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: var(--v2026-surface);
}

.message-display {
  flex: 1 1 auto;
  min-height: 0;
  padding-left: 24px;
  padding-right: 24px;

  background: var(--chat-bg);
}

::v-deep .v2026-info,
::v-deep .v2026-composer {
  flex: 0 0 auto;
}

.v2026-empty {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - var(--v2026-header-h));
  background: #f7f8fa;
}

.v2026-empty img {
  width: 250px;
  opacity: 1;
  margin-bottom: 16px;
}

.v2026-empty p {
  font-size: 15px;
  color: var(--v2026-text-muted);
}

.overflow-hidden {
  overflow: hidden;
}

.download-button {
  padding: 10px 20px;
  background-color: var(--v2026-teal);
  color: white;
  border: none;
  border-radius: var(--v2026-r-box);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.download-button:hover {
  background-color: var(--v2026-teal-hover);
}

::v-deep .customer-chat {
  background: var(--v2026-surface) !important;
  opacity: 1 !important;
  box-shadow: none !important;
  border: 1px solid var(--v2026-border) !important;
  // border-top-left-radius: 100px !important;
  // border-top-right-radius: 100px !important;
  // border-bottom-right-radius: 100px !important;
  // border-bottom-left-radius: 14px !important;
  border-radius: 14px !important;
}

::v-deep .admin-chat {
  background: #dcedc8 !important;
  border-radius: var(--v2026-r-bubble) !important;
  box-shadow: none !important;
  border: 0 !important;
}

::v-deep .customer-chat .card-body,
::v-deep .admin-chat .card-body {
  color: var(--v2026-text);
  font-size: 16px;
}

::v-deep .text-chat-time {
  color: var(--v2026-text-muted);
  font-size: 14px;
}

::v-deep .image-cropper-md .img-circle,
::v-deep .d-flex.justify-content-end .img-circle {
  width: 40px !important;
  height: 40px !important;
  object-fit: cover;
}

::v-deep .d-flex.justify-content-end .text-smaller.text-muted.pt-2 {
  width: 100%;
  text-align: center;
  color: var(--v2026-text-muted);
  font-size: 12px;
  letter-spacing: 0.2px;
}

.v2026-incognito-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 auto;
  min-height: 48px;
  padding: 8px 16px;
  background: #48484A;
  border-bottom: none;
}

.v2026-incognito-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.v2026-incognito-glyph {
  display: inline-block;
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: #fff;
}

.v2026-incognito-label {
  font-size: var(--v2026-fs-ctrl);
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v2026-incognito-close {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
  height: var(--v2026-ctrl-h);
  padding: 0 12px;
  border: 1px solid var(--v2026-border);
  border-radius: var(--v2026-r-btn);
  background: #fff;
  color: var(--v2026-text);
  font-size: var(--v2026-fs-ctrl);
  font-weight: 600;
  transition: background-color 150ms ease;
}

.v2026-incognito-close:hover {
  background: #f0f1f3;
}

.v2026-incognito-close:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);
}

.v2026-incognito-status {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 120px;
  color: var(--v2026-text-muted);
  font-size: 15px;
}
</style>
